import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, CardBody, CardTitle, Col, Row, Table } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { DesktopContainer } from '../layouts';
import { api, constants, dateHelpers, filterHelpers, storage, UserContext } from '../utils';

export default function MobileRepairs() {
  const { currentUser } = useContext(UserContext);
  const navigate = useNavigate();
  const ALL_MACHINES = { value: 0, label: "-- All --" };
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState([
    { filterName: "machineId", value: ALL_MACHINES }
  ]);
  const [id, setId] = useState(0);
  const [initialized, setInitialized] = useState(false);
  const [isEditor, setEditor] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [machines, setMachines] = useState([]);

  useEffect(() => {
    async function Init() {
      if (!currentUser) return;

      api
        .fetch(`Repair/InitRepairSearch`)
        .then(response => {
          if (response.data.success) {
            setEditor(response.data.canEdit);
            const machineList = _.concat([ALL_MACHINES],
              _.map(response.data.machines, m => ({ value: m.id, label: m.name })));
            return { machineList: machineList };
          } else {
            throw new Error(response);
          }
        }).then(async ({ machineList }) => {
          setMachines(machineList);
          let tmpFilters = JSON.parse(storage.getItem("rwoMobileSearchFilter"));
          if (tmpFilters) {
            setFilters(tmpFilters);
            setId(tmpFilters[0].value.value);
          }
          setInitialized(true);
        })
        .catch((error) => {
          api.catchHandler(error);
          toast.error(error);
        })
    }
    Init();
    // below line stops the "React Hook useEffect has missing dependencies" eslint error
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser])

  useEffect(() => {
    if (!loaded && initialized) { runQuery(); }
    // below line stops the "React Hook useEffect has missing dependencies" eslint error
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded, initialized])

  function createOrder() {
    var nav = constants.ENDPOINTS.mobileRwoScan + "/" + id;   // passing a machine type id
    navigate(nav);
  }

  function editOrder(workOrderId) {
    var nav = constants.ENDPOINTS.mobileRwoEdit + "/" + workOrderId;
    navigate(nav);
  }

  function onMachineChange(newFilterValue) {
    const mach = _.find(machines, x => x.value === newFilterValue.value);
    let newFilters = filterHelpers.getFilters(filters, ({ filterName: "machineId", value: mach }));
    setFilters(newFilters);
    storage.setItem("rwoMobileSearchFilter", JSON.stringify(newFilters));
    setId(newFilterValue.value);
    setLoaded(false);
  }

  function runQuery() {
    api
      .post(`Repair/GetOpenRepairs/${id}`)
      .then(response => {
        if (response.data.success) {
          if (response.data.hasResults) {
            setData(response.data.repairs);
          }
          else {
            setData([]);
            toast.info("No results were found for that selection");
          }
          setLoaded(true);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        api.catchHandler(error);
      })
  }

  return (
    <>
      <DesktopContainer screenName="Repair Work Orders">
        <ServiceThreadSpinner on={!loaded}>
          {loaded ?
            <div>
              <Row className="align-items-center my-1">
                <Col className="h6 fw-bold" xs={12}>
                  Machine Type:
                </Col>
              </Row>
              <Row className="align-items-center my-1">
                <Col xs={12}>
                  <FilterSelect
                    filterName="machineId"
                    options={machines}
                    value={filterHelpers.getValue(filters, "machineId")}
                    onChangeCallback={e => onMachineChange(e)}
                  />
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col xs="12">
                  <Button
                    title="newRwo"
                    className="shredButton w-100 btn-md my-3"
                    onClick={() => { createOrder(); }}>
                    Create New RWO
                  </Button>
                </Col>
              </Row>
            </div>
            : null
          }
          {loaded && data ?
            <div>
              <Row><Col><hr className="my-0" /></Col></Row>
              <Row className="align-items-center my-1">
                <Col className="h6 fw-bold" xs={12}>
                  Open Orders
                </Col>
              </Row>
              {_.map(data, (item, index) => {
                console.log("item is", item)
                return (
                  <div details={item} key={index} >
                    <Card className="py-0">
                      <CardBody className={(index % 2 === 0) ? "mobileBlueBg py-2 px-2" : "mobileBlueBgAlt py-2 px-2"}>
                        <CardTitle className={(index % 2 === 0) ? "mobileBlueBg py-1 px-1 my-0" : "mobileBlueBgAlt py-1 px-1 my-0"}>
                          <Table borderless size="sm" className="m-0">
                            <tbody>
                              <tr>
                                {isEditor ?
                                  <td colSpan="2" className="data-cell my-0 py-0">
                                    <label className="text-white h6 fw-bold m-0">{item.machineName}</label>
                                  </td>
                                  : null
                                }
                                {!isEditor ?
                                  <td className="data-cell my-0 py-0">
                                    <label className="text-white h6 fw-bold m-0">{item.machineName}</label>
                                  </td>
                                  : null
                                }
                              </tr>
                              <tr>
                                <td className="data-cell my-0 py-0" width="75px">
                                  <label className="text-white h6 fw-bold m-0">{item.displayId}</label>
                                </td>
                                {isEditor ?
                                  <td className="data-cell my-0 py-0">
                                    <Button children="Edit" className="btn w-100 btn-sm" onClick={() => {
                                      editOrder(item.workOrderId);
                                    }} />
                                  </td>
                                  : null
                                }
                              </tr>
                            </tbody>
                          </Table>
                        </CardTitle>
                        {item.workOrderId > 0 ?
                          <Table borderless size="sm">
                            <tbody>
                              <tr>
                                <td className="data-cell my-0 py-0" width="75px">
                                  <label className="text-black h6 fw-bold my-0">Entered:</label>
                                </td>
                                <td className="data-cell my-0 py-0">
                                  <label className="text-white h6 mx-1 my-0">{dateHelpers.dateTimeFormat(item.enteredDate, "MM-DD-YYYY HH:mm")}</label>
                                </td>
                              </tr>
                              <tr>
                                <td className="data-cell my-0 py-0">
                                  <label className="text-black h6 fw-bold my-0">Machine:</label>
                                </td>
                                <td className="data-cell my-0 py-0">
                                  <label className="text-white h6 mx-1 my-0"># {item.machineNumber}</label>
                                </td>
                              </tr>
                              <tr>
                                <td className="data-cell my-0 py-0">
                                  <label className="text-black h6 fw-bold my-0">Spindle:</label>
                                </td>
                                <td className="data-cell my-0 py-0">
                                  <label className="text-white h6 mx-1 my-0"># {item.spindle}</label>
                                </td>
                              </tr>
                              <tr>
                                <td className="data-cell my-0 py-0">
                                  <label className="text-black h6 fw-bold my-0">Side:</label>
                                </td>
                                <td className="data-cell my-0 py-0">
                                  <label className="text-white h6 mx-1 my-0">{item.machineSide}</label>
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="2" className="data-cell my-0 py-0">
                                  <label className="text-white h6 mx-1 my-0">{item.problem}</label>
                                </td>
                              </tr>
                              {item.problemChild ?
                                <tr>
                                  <td colSpan="2" className="data-cell my-0 py-0">
                                    <label className="text-white h6 mx-1 my-0">{item.problemChild}</label>
                                  </td>
                                </tr>
                                : null
                              }
                            </tbody>
                          </Table>
                          : null
                        }
                      </CardBody>
                    </Card>
                  </div>
                )
              })}
            </div>
            : null
          }
        </ServiceThreadSpinner>
      </DesktopContainer >
    </>
  );
}
